/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// Initialize usal on initial load
export const onClientEntry = () => {
    const usal = require("usal");
    if (typeof usal === "function") {
        usal();
    }
};

// Reinitialize usal on route change
export const onRouteUpdate = () => {
    const usal = require("usal");
    if (typeof usal === "function") {
        usal();
    }
};

// Scroll to top on route change
export const shouldUpdateScroll = () => {
    window.scrollTo(0, 0);
    if (window.lenis) {
        window.lenis.scrollTo(0, { immediate: true });
    }

    return false;
};
